import { z } from 'zod';
// Super-admin data-management DTOs (snake_case wire contract). Staged edits to
// platform-maintained data (personas, company attributes) with accept-to-apply
// versioning. See packages/db/src/schema/data-management.ts and the plan.
export const PROPOSED_ENTITY_TYPES = [
    'persona',
    'company_enrichment',
    'agent',
];
export const CHANGE_KINDS = ['material', 'silent'];
export const PROPOSED_CHANGE_STATUSES = [
    'open',
    'applied',
    'discarded',
    'superseded',
];
export const proposedDataChangeSchema = z.object({
    id: z.string(),
    entity_type: z.enum(PROPOSED_ENTITY_TYPES),
    entity_key: z.string(),
    scope: z.string(),
    base_snapshot: z.record(z.string(), z.unknown()).nullable(),
    proposed: z.record(z.string(), z.unknown()),
    change_kind: z.enum(CHANGE_KINDS),
    status: z.enum(PROPOSED_CHANGE_STATUSES),
    proposed_by: z.string().nullable(),
    note: z.string().nullable(),
    created_at: z.string(),
    updated_at: z.string(),
});
export const proposedDataChangesListResponseSchema = z.object({
    changes: z.array(proposedDataChangeSchema),
});
// Stage a change (super-admin). `apply_direct: true` bypasses staging + the
// accept-to-apply safety and writes live immediately — early-testing only,
// behind an explicit UI confirmation.
export const proposeDataChangeRequestSchema = z.object({
    entity_type: z.enum(PROPOSED_ENTITY_TYPES),
    entity_key: z.string().min(1).max(255),
    proposed: z.record(z.string(), z.unknown()),
    change_kind: z.enum(CHANGE_KINDS).default('material'),
    scope: z.string().max(64).default('global'),
    note: z.string().max(2000).optional(),
    apply_direct: z.boolean().optional(),
});
//# sourceMappingURL=data-management.js.map